<script setup>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import store from '../stores/store';

const router = useRouter();
const route = useRoute();
//const store = useStore();
//const { user, token, getUser, getPermissions, getToken } = storeToRefs(store);

import AppMenuItem from './AppMenuItem.vue';

const adminModel = ref([
    {
        items: [
            { label: 'Dashboard', icon: 'icon icon-24 icon-dashboard', to: '/', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'AF Sales Managers', icon: 'icon icon-24 icon-af-sales-managers', to: '/af-sales-managers', scopes: ['super_admin', 'admin'] },
            { label: 'Seller Companies', icon: 'icon icon-24 icon-seller-company', to: '/seller-companies', scopes: ['super_admin', 'admin'] },
            { label: 'Seller Contacts', icon: 'icon icon-24 icon-seller-contact', to: '/seller-contacts', scopes: ['super_admin', 'admin'] },
            /* { label: 'My Team', icon: 'icon icon-24 icon-team', to: '/my-team', scopes: ['sales_manager'] }, */
            { label: 'Buyer Companies', icon: 'icon icon-24 icon-buyer-company', to: '/buyer-companies', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Buyer Contacts', icon: 'icon icon-24 icon-buyer-contact', to: '/buyer-contacts', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Promotional Materials', icon: 'icon icon-24 icon-award-certificate', to: '/promotional-materials', scopes: ['sales_manager', 'sales_person'] },
            { label: 'Quotes', icon: 'icon icon-24 icon-quotes', to: '/quotes', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Tiers', icon: 'icon icon-24 icon-tiers', to: '/tiers', scopes: ['super_admin', 'admin'] }
        ]
    }
]);

const sellerCompany = ref([
    {
        items: [
            { label: 'Dashboard', icon: 'icon icon-24 icon-dashboard', tab: '0', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Sales Team', icon: 'icon icon-24 icon-users-6', tab: '1', scopes: ['super_admin', 'admin'] },
            { label: 'Opportunities', icon: 'icon icon-24 icon-suitcase-search', tab: '10', scopes: ['super_admin', 'admin','sales_manager', 'sales_person'] },
            { label: 'Promotional Materials', icon: 'icon icon-24 icon-award-certificate', tab: '9', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Quotes', icon: 'icon icon-24 icon-quotes', tab: '8', scopes: ['super_admin', 'admin'] },
            { label: 'Tiers', icon: 'icon icon-24 icon-tiers', tab: '6', scopes: ['super_admin', 'admin'] },
        ]
    }
]);

const sellerCompanyManage = ref([
    {
        items: [
            { label: 'Dashboard', icon: 'icon icon-24 icon-dashboard', tab: '0', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Sales Team', icon: 'icon icon-24 icon-users-6', tab: '1', scopes: ['super_admin', 'admin', 'sales_manager'] },
            { label: 'Basic Info', icon: 'icon icon-24 icon-suitcase-search', tab: '2', scopes: ['super_admin', 'admin'] },
            { label: 'Addresses', icon: 'icon icon-24 icon-location', tab: '3', scopes: ['super_admin', 'admin'] },
            { label: 'Emails', icon: 'icon icon-24 icon-envelope', tab: '4', scopes: ['super_admin', 'admin'] },
            { label: 'Phones', icon: 'icon icon-24 icon-phone', tab: '5', scopes: ['super_admin', 'admin'] },
            { label: 'Tier', icon: 'icon icon-24 icon-tiers', tab: '6', scopes: ['super_admin', 'admin'] },
            { label: 'Buyers', icon: 'icon icon-24 icon-buyer-company', tab: '7', scopes: ['super_admin', 'admin'] },
            { label: 'Promotional Materials', icon: 'icon icon-24 icon-award-certificate', tab: '9', scopes: ['super_admin', 'admin', 'sales_manager', 'sales_person'] },
            { label: 'Quotes', icon: 'icon icon-24 icon-quotes', tab: '8', scopes: ['super_admin', 'admin'] },
        ]
    }
]);

const cancelImpersonation = () => {
    //set seller company data and redirect to root page if impersonation came from seller company views
    if(store.impersonationSource == 'seller_company') {
        store.contextMenu ='seller-company';
        store.activeSellerCompanyId = store.user.company.Id;
        store.activeSellerCompany = store.user.company.FullLegalBusinessName;
        store.materialWizard.material.seller_company_id = store.user.company.Id;
    }
    let navTarget = store.user.company.Id;
    store.user = store.impersonator;
    store.impersonator = {};
    if(store.impersonationSource == 'seller_company') {
        router.push({
            path: '/seller-companies/'+store.activeSellerCompanyId,
        });
    }
    if(store.impersonationSource == 'admin') {
        router.push({
            path: '/seller-companies/',
        });
    }
}

const exitSeller = () => {
    store.contextMenu ='main';
    store.activeSellerCompanyId = null;
    store.activeSellerCompany = null;
    store.activeSellerTab = '0';
    store.activeSellerManage = false;
    store.materialWizard.material.seller_company_id = null;
    router.push({
        path: '/seller-companies/',
    });
}

</script>

<template>
    <div class="flex flex-col justify-between" style="height:calc(100vh - 7rem)">
        <div>
            <div class="text-2xl text-primary font-thin pb-6" style="font-family: PoppinsExtraLight" v-if="store.contextMenu === 'seller-company'">
                {{ store.activeSellerCompany }}
            </div>
            <ul class="layout-menu" v-if="store.contextMenu === 'main'">
                <template v-for="(item, i) in adminModel" :key="item">
                    <app-menu-item v-if="!item.separator" :item="item" :index="i" :class="item.class"></app-menu-item>
                    <li v-if="item.separator" class="menu-separator"></li>
                </template>
            </ul>
            <ul class="layout-menu" v-if="store.contextMenu === 'seller-company' && !store.activeSellerManage">
                <template v-for="(item, i) in sellerCompany" :key="item">
                    <app-menu-item v-if="!item.separator" :item="item" :index="i" :class="item.class"></app-menu-item>
                    <li v-if="item.separator" class="menu-separator"></li>
                </template>
            </ul>
            <ul class="layout-menu" v-if="store.contextMenu === 'seller-company' && store.activeSellerManage">
                <template v-for="(item, i) in sellerCompanyManage" :key="item">
                    <app-menu-item v-if="!item.separator" :item="item" :index="i" :class="item.class"></app-menu-item>
                    <li v-if="item.separator" class="menu-separator"></li>
                </template>
            </ul>
        </div>
        <div class="flex flex-col justify-start gap-4">
            <Button icon="pi pi-times" label="Cancel Impersonation" severity="info" text v-if="Object.keys(store.impersonator).length > 0" @click.prevent="cancelImpersonation" />
            <Button v-if="store.contextMenu === 'seller-company' && !store.activeSellerManage" icon="pi pi-cog" label="Manage Company" severity="primary" @click.prevent="store.activeSellerManage = true" />
            <Button v-if="store.contextMenu === 'seller-company' && !store.activeSellerManage" icon="pi pi-times" label="Exit" severity="danger" @click.prevent="exitSeller" />
            <Button v-if="store.contextMenu === 'seller-company' && store.activeSellerManage" icon="pi pi-times" label="Close" severity="info" @click.prevent="store.activeSellerManage = false" />
        </div>
    </div>
</template>

<style lang="scss" scoped></style>
